import React, { useEffect, useState, useCallback } from "react";
import { Box, Flex, Spinner, useToast } from "@chakra-ui/react";
import ApiResponse from "../../../services/ApiResponse";
import TableCRUD from "../../../components/TableCRUD";
import { getDecodedToken } from "../../../services/Token";
import { Evento, EventoForTable } from "../../../services/models/Evento";
import UnauthorizedPage from "../../UnauthorizedPage";
import ServerErrorPage from "../../ServerErrorPage";

const HEADERS = [
  "Título", "Descripción", "Ubicación", "Institución","Organizador",
  "Inicio", "Fin","Tipo",
  "Likes", "Dislikes", "Creado en"
];

const EventosTablePage = () => {
  const [response, setResponse] = useState(new ApiResponse<EventoForTable[]>());
  const decoded = getDecodedToken();
  const toast = useToast();

  const fetchEventos = useCallback(async () => {
    let apiResponse = new ApiResponse<EventoForTable[]>();
    
    // Usar el endpoint /eventos/table que devuelve datos especiales para la tabla
    await apiResponse.useFetch("eventos/table", "GET");

    if (apiResponse.data) {
      console.log("Eventos fetched for table:", apiResponse.data);
      apiResponse.data.sort((a, b) => a.titulo.localeCompare(b.titulo));
    }

    setResponse(apiResponse);
  }, [decoded?.rol_id, decoded?.institucion_id]);

  useEffect(() => {
    fetchEventos();
  }, [fetchEventos]);

  if (response.loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" thickness="4px" speed="0.65s" color="teal.500" />
      </Flex>
    );
  }

  switch (response.responseCode) {
    case 200:
      return (
        <Box p={5} minH="100vh">
          <TableCRUD
            tableName="eventos"
            headers={HEADERS}
            data={response.data || []}
            infoColumn="titulo"
          />
        </Box>
      );
    case 401:
      return <UnauthorizedPage />;
    case 999:
    default:
      if (!response.loading && response.responseCode !== 0) {
        return <ServerErrorPage />;
      }
      return null;
  }
};

export default EventosTablePage;
